import React, {useContext, useMemo} from 'react';

import Table from './../../common/table/Table';
import AppStatus from './AppStatus';

import ApplicationsService from './../../services/ApplicationService';

import { formatAmount, getFormatedDate } from '../../helpers/parsers';
import { getCurrentBranchUuId } from "../../helpers/token";
import { USER_ROLES } from "../../helpers/constants";
import { allStatesMap } from '../../helpers/states';
import { UserContext } from '../../context';

import './index.scss';

const columns = [
    {
        title: '',
        dataIndex: 'state',
        render: AppStatus,
    },
    {
        title: 'Դիմումի #',
        dataIndex: 'code',
        sorter: true,
        render: (v, data) => {
            return <a target='_blank' href={`/applications/${data.uuId}`}>{v}</a>
        },
    },
    {
        title: 'Ամսաթիվ և ժամ',
        dataIndex: 'created',
        sorter: true,
        render: (v) => getFormatedDate(v),
        className: 'custom-column',
    },
    {
        title: 'Հաճախորդ',
        dataIndex: 'customerName',
        sorter: false,
        className: 'custom-column',
    },
    {
        title: 'Հեռախոս',
        dataIndex: 'phoneNumber',
        sorter: false,
        className: 'custom-column',
    },
    {
        title: 'Կարգավիճակ',
        dataIndex: 'state',
        sorter: false,
        render: (v) => allStatesMap.get(v),
        className: 'custom-column',
    },
    {
        title: 'Մասնաճյուղ',
        dataIndex: 'branchName',
        sorter: false,
    },
    {
        title: 'Սպասարկող',
        dataIndex: 'lastModifiedUser',
        sorter: false,
    },
    {
        title: 'Գումար',
        dataIndex: 'amount',
        sorter: false,
        className: 'column-bold',
        render: (v) => formatAmount(v),
    },
];

const Applications = () => {
    const currentUser = useContext(UserContext);
    const currentBranch = useMemo(() => currentUser.branches.find(branch => branch.uuId === getCurrentBranchUuId()), []);

    return (
        <div>
            <Table
                userRole={USER_ROLES[currentUser.role.name]}
                currentBranch={currentBranch}
                branches={currentUser.branches}
                getData={(opt) => ApplicationsService.getApplications(opt)}
                columns={columns}
            />
        </div>
    )
};

export default Applications;